import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const ModuleCard = ({ 
  title, 
  icon, 
  iconColor, 
  stats, 
  route, 
  alerts = [] 
}) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(route)}
      className="card text-left transition-smooth hover:shadow-warm-lg hover:border-accent group"
    >
      <div className="flex items-start justify-between mb-6">
        <div className="h-14 w-14 rounded-lg flex items-center justify-center transition-smooth group-hover:scale-110"
             style={{ backgroundColor: `${iconColor}15` }}>
          <Icon name={icon} size={28} color={iconColor} />
        </div>
        <Icon name="ArrowRight" size={20} color="var(--color-muted-foreground)" 
              className="transition-smooth group-hover:translate-x-1 group-hover:text-accent" />
      </div>
      <h3 className="text-xl font-semibold text-foreground mb-4 font-heading">{title}</h3>
      <div className="space-y-3 mb-4">
        {stats?.map((stat, index) => (
          <div key={index} className="flex items-center justify-between">
            <span className="text-sm text-muted-foreground font-caption">{stat?.label}</span>
            <span className="text-lg font-semibold text-foreground font-data">{stat?.value}</span>
          </div>
        ))}
      </div>
      {alerts?.length > 0 && (
        <div className="pt-4 border-t border-border space-y-2">
          {alerts?.map((alert, index) => (
            <div key={index} className="flex items-center gap-2">
              <div className="h-2 w-2 rounded-full" style={{ backgroundColor: alert?.color }} />
              <span className="text-xs text-muted-foreground font-caption">{alert?.text}</span>
            </div>
          ))}
        </div>
      )}
    </button>
  );
};

export default ModuleCard;